import React from 'react';

import HCard from './HCard';

class Overview extends React.Component {

  componentDidMount() {

  }

  render() {
    return (
      <section className='overview'>
        <div className='row'>
          <div className='col-sm-3'>
            <HCard iconName='users' backgroundColor='tealBG' label='Total registered' number={42356} />
          </div>
          <div className='col-sm-3'>
            <HCard iconName='tags' backgroundColor='pinkBG' label='Online' number={1256} />
          </div>
          <div className='col-sm-3'>
            <HCard iconName='shopping-cart' backgroundColor='amberBG' label='revenue' number={178356} prefix='$' />
          </div>
        </div>
      </section>
    )
  }
}

export default Overview;


// WEBPACK FOOTER //
// ./src/components/Overview.js